@use '../../design-tokens/typography/typography' as *;
@use './shared-input' as *;

@layer design-system {
  .sharedInput {
    @include shared-input-styles;
  }

  .container {
    width: auto;
  }

  .inputElement {
    composes: sharedInput;

    &.large {
      @include typography-v2-body-base;
    }

    &.medium {
      @include typography-v2-body-sm;
    }

    &.rightAlignText {
      text-align: right;
    }

    &.disabled {
      color: var(--text-disabled);
    }

    &:not(.disabled) {
      color: var(--text-default);
    }
  }

  .prefixContainer {
    color: var(--text-soft);
  }

  .inputWrapper {
    display: flex;
    border-radius: 4px;
    overflow: hidden;
    padding: 8px 12px;
    position: relative;
    border: 1px solid var(--border-default);
    gap: 8px;
    align-items: center;

    &.fill {
      background-color: var(--surface-default);
    }

    &.outline {
      background-color: transparent;
    }

    &.isDisabled {
      border-color: var(--border-disabled);
      cursor: default;

      .prefixContainer {
        color: var(--surface-neutral);
      }

      svg {
        fill: var(--surface-neutral);
      }
    }

    &:not(.isDisabled) {
      &.error {
        border-color: var(--border-critical);
      }

      &:not(.error).focused {
        border-color: var(--border-primary);
      }

      &:not(.error, .focused):hover {
        border-color: var(--border-hover);
      }
    }
  }

  .leftIcon {
    width: auto;
    display: flex;
    align-items: center;
  }

  .rightIcon {
    width: auto;
    display: flex;
    align-items: center;
  }

  .errorLabel {
    display: block;
    text-align: left;
    margin-top: 6px;
    color: var(--text-critical);
    @include typography-v2-body-sm;
  }

  .helperLabel {
    composes: errorLabel;
    color: var(--text-soft);
  }

  .styledLabel {
    display: block;
    @include typography-v2-body-sm;
    color: var(--text-default);
    margin-bottom: 4px;
  }
}
